module.exports = __webpack_public_path__ + "static/media/lock.c3690fa6.svg";